const $ = require('jquery');

module.exports = function (glossaryElement) {
    var data = JSON.parse(glossaryElement.innerText);
    this.chapters = data.chapters;
    this.introduction = data.introduction;
    this._transitioning = false;

    var $this = this;

    this.setupAllListeners = function () {
        // Event delegation for all chapter links
        $(document).on('click', '[data-chapter]', function (e) {
            if ($this._transitioning) {
                e.preventDefault();
                return;
            }
            var slug = $(this).attr('data-chapter');
            if (!slug) return;

            var target;
            if (slug === '__intro__') {
                target = '__intro__';
            } else {
                target = $this.find(slug);
            }

            if (target !== undefined) {
                e.preventDefault();
                $this._transitioning = true;
                setTimeout(function () { $this._transitioning = false; }, 600);
                if (target === '__intro__') {
                    $this.displayIntroduction();
                } else {
                    $this.display(target);
                }
                $this.updateChapterCounter(slug);
            }
        });

    }

    this.display = function (chapter) {
        var wrapper = $('#main-content');

        wrapper.find("[data-field='content']").html(chapter['content']);

        if (chapter['relations']['previous'] != undefined) {
            var slug = chapter['relations']['previous'];
            var url = $('#glossary-list').find('[data-chapter="' + slug + '"]').attr('href');
            $('[data-glossary-previous-chapter]').attr('href', url).attr('data-chapter', slug).show();
            $('[data-glossary-previous-label]').text('Chapitre precedent');
        } else {
            var introUrl = $('#glossary-list a[data-chapter="__intro__"]').attr('href');
            $('[data-glossary-previous-chapter]').attr('href', introUrl).attr('data-chapter', '__intro__');
            $('[data-glossary-previous-label]').text("Retour a l'introduction");
        }

        if (chapter['relations']['next'] != undefined) {
            var slug = chapter['relations']['next'];
            var url = $('#glossary-list').find('[data-chapter="' + slug + '"]').attr('href');
            $('[data-glossary-next-chapter]').attr('href', url).attr('data-chapter', slug).show();
            $('[data-glossary-next-label]').text('Chapitre suivant');
        } else {
            $('[data-glossary-next-chapter]').attr('href', 'javascript:void(0)').removeAttr('data-chapter');
            $('[data-glossary-next-label]').text('');
        }

        wrapper.trigger("chapter-updated", [chapter]);
    }

    this.displayIntroduction = function () {
        var wrapper = $('#main-content');
        var intro = this.introduction;

        var html = '';
        if (intro.subtitle) {
            html += '<p class="subtitle">' + intro.subtitle + '</p>';
        }
        html += intro.content;
        if (intro.map_image) {
            html += '<div class="country-map"><img data-src="' + intro.map_image + '" data-lazy alt="Tirawa : Carte du pays ' + (intro.map_country_name || '') + '" loading="lazy"/></div>';
        }
        wrapper.find("[data-field='content']").html(html);

        // No previous on introduction
        $('[data-glossary-previous-chapter]').attr('href', 'javascript:void(0)').removeAttr('data-chapter');
        $('[data-glossary-previous-label]').text('');

        // Next = first chapter
        if (this.chapters.length > 0) {
            var firstSlug = this.chapters[0]['slug'];
            var url = $('#glossary-list').find('[data-chapter="' + firstSlug + '"]').attr('href');
            $('[data-glossary-next-chapter]').attr('href', url).attr('data-chapter', firstSlug).show();
            $('[data-glossary-next-label]').text('Chapitre suivant');
        }

        wrapper.trigger("chapter-updated", [{slug: '__intro__', title: intro.title}]);
    }

    this.updateChapterCounter = function (slug) {
        if (slug === '__intro__') {
            $('#current-chapter').text('Introduction');
            $('.chapter-total').hide();
        } else {
            var idx = this.findIndex(slug);
            if (idx !== undefined) {
                $('#current-chapter').text('Chapitre ' + (idx + 1));
                $('.chapter-total').show();
            }
        }
    }

    this.find = function (chapterSlug) {
        for (var i = 0; i < this.chapters.length; i++) {
            if (this.chapters[i]['slug'] == chapterSlug) {
                return this.chapters[i];
            }
        }
    }

    this.findIndex = function (chapterSlug) {
        for (var i = 0; i < this.chapters.length; i++) {
            if (this.chapters[i]['slug'] == chapterSlug) {
                return i;
            }
        }
    }
}
